<template>
  <v-dialog
    v-model="enableDialog"
    scrollable
    width="800"
    @click:outside="closeButtonClickEvent"
  >
    <v-card>
      <v-card-title>
        運搬ルート
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="transport_routes"
          :items-per-page="-1"
          disable-pagination
          disable-sort
          hide-default-footer
        >
          <template v-slot:[`item.updated_at`]="{ item }">
            {{ item.updated_at | unix_datetime_format }}
          </template>
          <template v-slot:[`item.invisible`]="{item}">
            {{ item.invisible ? '非表示' : '' }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClickEvent">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
      tableHeaders: [
        { value: 'tenant_name', text: 'テナント' },
        { value: 'route_name', text: 'ルート名' },
        { value: 'invisible', text: '非表示' },
        { value: 'updated_at', text: '更新日時' },
      ],
      transport_routes: [],
    }
  },
  watch: {
    enableDialog (value) {
      if (value) {
        if (this.targetId) {
          this.searchShowTransportRoutes()
        }
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('AdminMasterTransportRoute', {
      showTransportRoutes: 'index',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },

    /**
     * ルート情報取得
     */
     searchShowTransportRoutes () {
      this.showTransportRoutes({ id: this.targetId }).then((content) => {
        this.transport_routes = content.transport_routes
      })
    },
  }
}
</script>

<style scoped>
</style>
